import "./state-types"
import moment from "moment"

const getRouteItem = (state: routeItemState) => (id: number) => {
  let routeItem = JSON.stringify(
    state.routeItems.find((el: any) => {
      if (el.id == id || el.uuid == id) {
        return el
      }
    })
  ) as any

  if (routeItem) {
    routeItem = JSON.parse(routeItem)
    if (Object.keys(routeItem).length) {
    }
  }
  return routeItem
}

export default {
  getRouteItem,
}
